<template>
  <div class="card-item-wrap">
    <div :class="['data-item', isCur ? 'cur' : '']" @click="handleCommand('edit')">
      <span>{{ title || dataSet.name }}</span>
      <el-dropdown trigger="click" size="small" @command="handleCommand">
        <i class="el-icon-more dot-icon"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="copy">复制</el-dropdown-item>
          <el-dropdown-item v-if="showDelete" command="del">删除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSet: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: "",
    },
    isCur: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleCommand(type) {
      this.$emit(type, this.dataSet);
    },
  },
};
</script>

<style lang="less" scoped>
.card-item-wrap {
  .data-item {
    display: inline-block;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    padding: 6px 8px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    margin: 0 14px 12px 0px;
    cursor: pointer;
    user-select: none;
    .dot-icon {
      transform: rotate(90deg);
      color: #666;
    }
    &.cur {
      border: 1px solid rgba(24, 144, 255, 1);
      color: rgba(24, 144, 255, 1);
      .dot-icon {
        color: rgba(24, 144, 255, 1);
      }
    }
  }
}
</style>
